import React, { Ref } from 'react';

import { CustomContentProps, closeSnackbar } from 'notistack';
import { Alert } from '@infoods/lifebase-ui';

const LbSnackbarAlert = ({
  variant,
  message,
  id,
  ref,
}: CustomContentProps & { ref: Ref<HTMLDivElement> }) => {
  return (
    <Alert ref={ref} severity={variant} onClose={() => closeSnackbar(id)}>
      {message}
    </Alert>
  );
};

export { LbSnackbarAlert };
